import type { RouterConfig } from '@nuxt/schema'
import type { RendererElement, RendererNode, VNode } from 'vue'

export default {
  scrollBehavior: async (to: any, from: any, savedPosition) => {
    const nuxtApp = useNuxtApp()

    const getOffset = () => {
      const headerHeight = useCssVar('--header-height')
      const raw = headerHeight.value ?? '0'
      return Number.parseFloat(raw) || 0
    }

    return new Promise((resolve) => {
      if (from?.path === to?.path) {
        if (to.hash) {
          nextTick(() => {
            resolve({
              el: to.hash,
              top: getOffset(),
              behavior: nuxtApp.isHydrating ? 'instant' : 'smooth',
            })
          })
          return
        }
        return resolve(false)
      }

      if (nuxtApp.isHydrating) {
        if (to.hash) {
          nuxtApp.hooks.hookOnce('app:mounted', () => {
            nextTick(() => {
              setTimeout(() => {
                resolve({
                  el: to.hash,
                  top: getOffset(),
                  behavior: 'instant',
                })
              }, 350)
            })
          })
          return
        }
        // Keep native browser restoration on first paint/reload.
        return resolve(false)
      }

      async function onPageTransitionFinish(_ctx: VNode<RendererNode, RendererElement, { [key: string]: any }> | undefined) {
        await nextTick()

        nuxtApp.hooks.removeHook('page:transition:finish', onPageTransitionFinish)

        if (savedPosition) {
          return resolve(savedPosition)
        }

        if (to.hash) {
          await new Promise(r => setTimeout(r, 150))
          return resolve({
            el: to.hash,
            top: getOffset(),
            behavior: 'instant',
          })
        }

        return resolve({ left: 0, top: 0 })
      }

      nuxtApp.hooks.hook('page:transition:finish', onPageTransitionFinish)
    })
  },
} satisfies RouterConfig
